import gsap from 'gsap';
import registerSectionAnimations from './animations/animateSection';
import registerSplitText from './animations/animateText';
import { createObserver } from "./shared";
import { isTablet } from './utils/breakpoints';

const 
section_3 = document.getElementById("section-3"),
questions = document.querySelectorAll('.question'),
etapes = document.querySelectorAll(".etapes>div");

//______RULES______//

const close = (question) => {
    const answer = question.querySelector(".answer");

    question.classList.remove("open");
    gsap.to(answer,{
        scaleY: 0,
        height: 0,
        marginTop: 0,
        autoAlpha: 0,
        duration: 0.25
    })
};

const open = (question) => {
    const answer = question.querySelector(".answer");

    question.classList.add("open");
    gsap.to(answer,{
        scaleY: 1,
        height: "auto",
        marginTop: "2rem",
        autoAlpha: 1,
        duration: 0.25
    })
};

const expend_rules = () => {
    questions.forEach(question => {
        question.addEventListener("click",() => {
            const current_open_question = document.querySelectorAll(".question.open")
            if(current_open_question.length >= 1){
                current_open_question.forEach(e => {
                    if(question === e) return;
                    close(e);
                })
            }
            open(question);
        })
    });
}

//______ANIMATES______//

let block_options = {
    root: null,
    rootMargin: isTablet? '0px':'300px',
    threshold: isTablet? 0.15 : 0.75
};

const animateEtapes = (target, observer) => {
  gsap.to(etapes,{
    autoAlpha:1,
    y:0,
    stagger: 0.5
  })
};

const etapes_observer = createObserver(block_options,animateEtapes);


//______INIT______//

const init = () => {
    expend_rules();
    registerSectionAnimations();
    etapes_observer.observe(section_3);
}

document.addEventListener('DOMContentLoaded',() => {
  init();
});

async function fontLoaded() {
    let ready = await document.fonts.ready;
    if(ready.status === "loaded"){
      registerSplitText();
    }
}

fontLoaded();
